module.exports = __webpack_public_path__ + "img/bg-poster-1.73b75bed.webp";